// Herhaling in gewone taal voor elke taal (oprichter 1 okt): de zinsdelen uit `a.recurrenceText`
// plus weekdag- en maandnamen uit Intl. Vorm = RecurrenceLang uit @amumin/domain (summaryLang.ts);
// structureel getypt, zodat i18n niet van domain afhangt. Webapp en API; nooit de kiosk.
import { appMessagesFor } from './catalogs.js';
import { intlCalendarNames, safeFormatter } from './intl.js';
import { getDisplayDigits, localizeDigits, normalizeLocale } from './locales.js';
import { nl } from './nl.js';
import { t } from './t.js';
const cache = {};
/**
 * Zinsdelen en namen voor een taal; `null` voor Nederlands (dan de vaste Nederlandse tekst van
 * summarizeRecurrence, gelijk aan de `*_nl`-velden).
 */
export function recurrenceLangFor(locale) {
    var _a;
    const code = normalizeLocale(locale);
    if (code === 'nl-NL')
        return null;
    const hit = cache[code];
    if (hit)
        return hit;
    const words = appMessagesFor(code).recurrenceText;
    const names = (_a = intlCalendarNames(code)) !== null && _a !== void 0 ? _a : nl;
    const lang = {
        text: (key, vars) => t(words[key], vars),
        weekday: (index) => { var _a; return (_a = names.weekdays[index]) !== null && _a !== void 0 ? _a : ''; },
        month: (month) => { var _a; return (_a = names.months[month - 1]) !== null && _a !== void 0 ? _a : ''; },
        date: (date) => {
            var _a;
            const [y, m, d] = date.split('-').map(Number);
            const digits = getDisplayDigits();
            const f = safeFormatter(code, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }, digits);
            if (f) {
                try {
                    return f.format(new Date(Date.UTC(y, m - 1, d, 12)));
                }
                catch {
                    // terugval hieronder
                }
            }
            return localizeDigits(`${d} ${(_a = names.months[m - 1]) !== null && _a !== void 0 ? _a : ''} ${y}`, digits);
        },
    };
    cache[code] = lang;
    return lang;
}
//# sourceMappingURL=recurrenceLang.js.map